document.addEventListener('DOMContentLoaded', function () {
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  const carousels = [
    {
      selector: '.header-announcement-bar .layout-panel-flex',
      options: {
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        autoPlay: 3000,
        selectedAttraction: 0.01,
friction: 0.15
      },
      mobileOnly: true
    },
        {
      selector: '.mobile_slider_gallery',
      options: {
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        autoPlay: 2000
      },
      mobileOnly: false
    }
  ];

  const instances = new Map();

  function initCarousel(config) {
    const el = document.querySelector(config.selector);
    if (!el || instances.has(config.selector)) return;

    const flkty = new Flickity(el, config.options);
    instances.set(config.selector, flkty);

    requestAnimationFrame(() => {
      flkty.resize();
    });
  }

  function destroyCarousel(config) {
    const flkty = instances.get(config.selector);
    if (flkty) {
      flkty.destroy();
      instances.delete(config.selector);
    }
  }

  function checkCarousels() {
    carousels.forEach(config => {
      if (config.mobileOnly && !mobileQuery.matches) {
        destroyCarousel(config);
      } else {
        initCarousel(config);
      }
    });
  }

  // Initial check
  checkCarousels();

  // Handle breakpoint changes
  mobileQuery.addEventListener('change', checkCarousels);

  // Shopify section reload safety
  document.addEventListener('shopify:section:load', function (event) {
    carousels.forEach(config => {
      if (event.target.querySelector(config.selector)) {
        destroyCarousel(config);
      }
    });
    checkCarousels();
  });


/* get header and footer hight and add to css root variable */
const headerHeight = document.querySelector('div#header-group').clientHeight;
const footerHeight = document.querySelector('.section.footer--2').clientHeight;
document.documentElement.style.setProperty('--theader-height', `${headerHeight}px`);
document.documentElement.style.setProperty('--tfooter-height', `${footerHeight}px`);



});
